import { ACCOUNT_TYPES, FISCAL_SPONSOR_CATEGORIES } from '../sponsfi/constants/accountingConstants';
import { AccountType, AccountCategory } from '../sponsfi/types/accounting';

// Rename to avoid conflict
export const ACCOUNT_TYPE_DEFINITIONS = [
  { code: 'ASSET', name: 'Asset', taxCode: '1000' },
  { code: 'LIABILITY', name: 'Liability', taxCode: '2000' },
  { code: 'EQUITY', name: 'Equity', taxCode: '3000' },
  { code: 'REVENUE', name: 'Revenue', taxCode: '4000' },
  { code: 'EXPENSE', name: 'Expense', taxCode: '5000' }
];

export const CHART_OF_ACCOUNTS = {
  "Assets": [
    // Current Assets
    { code: "1000", name: "Cash and Cash Equivalents", subcategories: [
      { code: "1010", name: "Operating Cash" },
      { code: "1020", name: "Savings Account" },
      { code: "1030", name: "Money Market Accounts" },
      { code: "1040", name: "Petty Cash" }
    ]},
    { code: "1100", name: "Accounts Receivable", subcategories: [
      { code: "1110", name: "Pledges Receivable - Current" },
      { code: "1120", name: "Grants Receivable - Current" },
      { code: "1130", name: "Program Fees Receivable" }
    ]},
    { code: "1200", name: "Investments", subcategories: [
      { code: "1210", name: "Marketable Securities" },
      { code: "1220", name: "Certificates of Deposit" },
      { code: "1230", name: "Endowment Investments" }
    ]},
    { code: "1300", name: "Prepaid Expenses", subcategories: [
      { code: "1310", name: "Prepaid Insurance" },
      { code: "1320", name: "Prepaid Rent" },
      { code: "1330", name: "Prepaid Program Expenses" }
    ]},
    
    // Fixed Assets
    { code: "1500", name: "Fixed Assets", subcategories: [
      { code: "1510", name: "Furniture and Equipment" },
      { code: "1520", name: "Vehicles" },
      { code: "1530", name: "Buildings" },
      { code: "1540", name: "Land" },
      { code: "1550", name: "Leasehold Improvements" }
    ]},
    { code: "1600", name: "Accumulated Depreciation" },
    { code: "1400", name: "Fiscal Sponsorship Assets", subcategories: [
      { code: "1410", name: "Sponsored Project Bank Accounts" },
      { code: "1420", name: "Fiscal Sponsorship Receivables" },
      { code: "1430", name: "Inter-Project Transfers" }
    ]}
  ],

  "Liabilities": [
    // Current Liabilities
    { code: "2000", name: "Accounts Payable", subcategories: [
      { code: "2010", name: "Vendor Payables" },
      { code: "2020", name: "Program Payables" },
      { code: "2030", name: "Grant Payables" }
    ]},
    { code: "2100", name: "Accrued Expenses", subcategories: [
      { code: "2110", name: "Accrued Payroll" },
      { code: "2120", name: "Accrued Vacation" },
      { code: "2130", name: "Accrued Benefits" }
    ]},
    { code: "2200", name: "Payroll Liabilities", subcategories: [
      { code: "2210", name: "Federal Withholding" },
      { code: "2220", name: "State Withholding" },
      { code: "2230", name: "FICA Payable" },
      { code: "2240", name: "Medicare Payable" }
    ]},
    
    // Long-term Liabilities
    { code: "2500", name: "Long-term Debt" },
    { code: "2300", name: "Fiscal Sponsorship Liabilities", subcategories: [
      { code: "2310", name: "Project Fund Balances" },
      { code: "2320", name: "Administrative Fees Payable" },
      { code: "2330", name: "Project Grant Obligations" }
    ]}
  ],

  "Net Assets": [
    { code: "3000", name: "Net Assets Without Donor Restrictions" },
    { code: "3100", name: "Net Assets With Donor Restrictions", subcategories: [
      { code: "3110", name: "Time Restricted" },
      { code: "3120", name: "Purpose Restricted" },
      { code: "3130", name: "Perpetual in Nature" }
    ]}
  ],

  "Revenue": [
    { code: "4000", name: "Contributions", subcategories: [
      { code: "4010", name: "Individual Donations" },
      { code: "4020", name: "Corporate Donations" },
      { code: "4030", name: "Foundation Donations" },
      { code: "4040", name: "Major Gifts" },
      { code: "4050", name: "Planned Giving" }
    ]},
    { code: "4100", name: "Grant Revenue", subcategories: [
      { code: "4110", name: "Government Grants" },
      { code: "4120", name: "Foundation Grants" },
      { code: "4130", name: "Corporate Grants" }
    ]},
    { code: "4200", name: "Program Revenue", subcategories: [
      { code: "4210", name: "Program Service Fees" },
      { code: "4220", name: "Workshop and Training Fees" },
      { code: "4230", name: "Membership Dues" }
    ]},
    { code: "4300", name: "Investment Income", subcategories: [
      { code: "4310", name: "Interest Income" },
      { code: "4320", name: "Dividend Income" },
      { code: "4330", name: "Realized Gains/Losses" },
      { code: "4340", name: "Unrealized Gains/Losses" }
    ]},
    { code: "4400", name: "In-Kind Contributions", subcategories: [
      { code: "4410", name: "Donated Services" },
      { code: "4420", name: "Donated Materials" },
      { code: "4430", name: "Donated Facilities" }
    ]},
    { code: "4500", name: "Fiscal Sponsorship Revenue", subcategories: [
      { code: "4510", name: "Administrative Fees" },
      { code: "4520", name: "Project Management Fees" },
      { code: "4530", name: "Grant Administration Fees" }
    ]}
  ],

  "Expenses": {
    "Program": [
      { code: "5000", name: "Program Salaries and Benefits", subcategories: [
        { code: "5010", name: "Program Staff Salaries" },
        { code: "5020", name: "Program Staff Benefits" },
        { code: "5030", name: "Program Staff Payroll Taxes" }
      ]},
      { code: "5100", name: "Program Operations", subcategories: [
        { code: "5110", name: "Program Supplies" },
        { code: "5120", name: "Program Equipment" },
        { code: "5130", name: "Program Space Rental" },
        { code: "5140", name: "Program Travel" }
      ]},
      { code: "5200", name: "Direct Assistance", subcategories: [
        { code: "5210", name: "Client Assistance" },
        { code: "5220", name: "Scholarships" },
        { code: "5230", name: "Grants to Others" }
      ]}
    ],

    "Administrative": [
      { code: "6000", name: "Management Salaries and Benefits", subcategories: [
        { code: "6010", name: "Administrative Salaries" },
        { code: "6020", name: "Administrative Benefits" },
        { code: "6030", name: "Administrative Payroll Taxes" }
      ]},
      { code: "6100", name: "Professional Services", subcategories: [
        { code: "6110", name: "Accounting Fees" },
        { code: "6120", name: "Legal Fees" },
        { code: "6130", name: "Consulting Fees" }
      ]},
      { code: "6200", name: "Office Operations", subcategories: [
        { code: "6210", name: "Office Supplies" },
        { code: "6220", name: "Office Equipment" },
        { code: "6230", name: "Telephone and Internet" },
        { code: "6240", name: "Postage and Shipping" }
      ]},
      { code: "6300", name: "Occupancy", subcategories: [
        { code: "6310", name: "Rent" },
        { code: "6320", name: "Utilities" },
        { code: "6330", name: "Maintenance" },
        { code: "6340", name: "Insurance" }
      ]},
      { code: "6400", name: "Technology", subcategories: [
        { code: "6410", name: "Software Subscriptions" },
        { code: "6420", name: "IT Support" },
        { code: "6430", name: "Website" }
      ]}
    ],

    "Fundraising": [
      { code: "7000", name: "Fundraising Salaries and Benefits", subcategories: [
        { code: "7010", name: "Fundraising Salaries" },
        { code: "7020", name: "Fundraising Benefits" },
        { code: "7030", name: "Fundraising Payroll Taxes" }
      ]},
      { code: "7100", name: "Fundraising Activities", subcategories: [
        { code: "7110", name: "Event Expenses" },
        { code: "7120", name: "Direct Mail" },
        { code: "7130", name: "Online Fundraising" }
      ]},
      { code: "7200", name: "Marketing and Communications", subcategories: [
        { code: "7210", name: "Advertising" },
        { code: "7220", name: "Printing" },
        { code: "7230", name: "Publications" }
      ]}
    ]
  }
};

export const FUND_CODES = [
  { code: "01", name: "General Operating Fund" },
  { code: "02", name: "Restricted Grants" },
  { code: "03", name: "Endowment" },
  { code: "04", name: "Capital Campaign" },
  { code: "05", name: "Scholarship Fund" }
];

export const COST_CENTERS = [
  { code: "CC01", name: "Administration" },
  { code: "CC02", name: "Programs" },
  { code: "CC03", name: "Fundraising" },
  { code: "CC04", name: "Marketing" }
];

export const GRANT_TYPES = [
  { code: "GR01", name: "Foundation Grants" },
  { code: "GR02", name: "Government Grants" },
  { code: "GR03", name: "Corporate Grants" }
];

export const EXPENSE_CATEGORIES = {
  "Personnel": [
    "Salaries and Wages",
    "Employee Benefits",
    "Payroll Taxes",
    "Professional Development"
  ],
  "Professional Services": [
    "Accounting",
    "Legal",
    "Consulting",
    "Contract Services"
  ],
  "Operations": [
    "Rent",
    "Utilities",
    "Insurance",
    "Office Supplies",
    "Technology"
  ],
  "Program": [
    "Program Supplies",
    "Program Events",
    "Client Services",
    "Training Materials"
  ],
  "Travel": [
    "Transportation",
    "Lodging",
    "Meals",
    "Conference Fees"
  ]
};

// Validation functions
export const validateAccountCode = (code: string, type: string) => {
  // Existing validation
  const isValid = Object.values(CHART_OF_ACCOUNTS)
    .flat()
    .some(account => account.code === code);

  // Add fiscal sponsorship specific validation
  const isFiscalSponsorshipValid = code.match(/^[1-4][0-9]{3}$/);
  
  return {
    isValid,
    isFiscalSponsorshipValid,
    errors: []
  };
};

export const validateFundCode = (code) => {
  return FUND_CODES.some(fund => fund.code === code);
};

// Helper functions
export const getAccountName = (code) => {
  const account = Object.values(CHART_OF_ACCOUNTS)
    .flat()
    .find(a => a.code === code);
  return account ? account.name : '';
};

export const getFundName = (code) => {
  const fund = FUND_CODES.find(f => f.code === code);
  return fund ? fund.name : '';
};

// Add specific fund types for fiscal sponsorship
export const FUND_TYPES = [
  { value: 'unrestricted', label: 'Unrestricted' },
  { value: 'temporarily_restricted', label: 'Temporarily Restricted' },
  { value: 'permanently_restricted', label: 'Permanently Restricted' },
  { value: 'endowment', label: 'Endowment' },
  { value: 'grant', label: 'Grant' },
  { value: 'program', label: 'Program Fund' },
  { value: 'fiscal_sponsored', label: 'Fiscal Sponsored Project' }
];

// Add fund restriction types
export const RESTRICTION_TYPES = [
  { value: 'time', label: 'Time Restricted' },
  { value: 'purpose', label: 'Purpose Restricted' },
  { value: 'both', label: 'Time and Purpose Restricted' },
  { value: 'none', label: 'No Restrictions' }
];

export const validateFundRestrictions = (fundType: string, restrictions: any) => {
  // Validate fund restrictions based on type
  const errors = [];
  
  if (fundType === 'fiscal_sponsored' && !restrictions.agreement) {
    errors.push('Fiscal Sponsorship Agreement is required');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Add fiscal sponsorship specific helpers
export const getFiscalSponsorshipAccounts = (causeId: string) => {
  return {
    assets: `1410.${causeId}`,
    receivables: `1420.${causeId}`,
    payables: `2310.${causeId}`,
    revenue: `4510.${causeId}`
  };
};

// Simplify the account code generation
export const generateAccountCode = (params: {
  type: string;
  category: string;
  causeType: string;
}) => {
  const { type, category, causeType } = params;
  
  // Find the base account type
  const accountType = ACCOUNT_TYPE_DEFINITIONS.find(at => at.code === type);
  if (!accountType) {
    throw new Error(`Invalid account type: ${type}`);
  }

  // Generate the code directly without subcategory lookup
  const baseCode = accountType.taxCode;
  const categoryCode = category === 'RESTRICTED' ? '1' : '0';
  const causeCode = causeType?.substring(0, 2).padStart(2, '0') || '00';

  return `${baseCode}${categoryCode}${causeCode}`;
};

export const generateTaxCode = (params: {
  type: string;
  category: string;
  entityType: string;
}) => {
  const { type, category, entityType } = params;
  
  const accountType = ACCOUNT_TYPE_DEFINITIONS.find(at => at.code === type);
  if (!accountType) {
    throw new Error(`Invalid account type: ${type}`);
  }

  const categoryModifier = category === 'RESTRICTED' ? '1' : '0';
  const entityModifier = entityType === '501c3' ? '1' : '0';

  return `${accountType.taxCode}${categoryModifier}${entityModifier}`;
};

export const handleSpecialAccountTypeChange = (selectedTypeCode: string, causeType: string) => {
  const selectedType = ACCOUNT_TYPE_DEFINITIONS.find(type => type.code === selectedTypeCode);
  if (!selectedType) {
    throw new Error(`Invalid account type: ${selectedTypeCode}`);
  }

  const category = selectedType.defaultCategory;
  
  const newCode = generateAccountCode({
    type: selectedTypeCode,
    category: category,
    causeType: causeType || 'GEN'
  });

  const newTaxCode = generateTaxCode({
    type: selectedTypeCode,
    category: category,
    entityType: '501c3'
  });

  return {
    accountCode: newCode,
    taxCode: newTaxCode,
    category: category,
    isRestricted: category === 'RESTRICTED'
  };
};

// Update validation for simplified code format
export const validateTaxCode = (code: string): boolean => {
  if (!code || code.length !== 6) return false;
  
  const baseCode = code.substring(0, 4);
  const categoryModifier = code.charAt(4);
  const entityModifier = code.charAt(5);
  
  const isValidBase = ACCOUNT_TYPE_DEFINITIONS.some(type => type.taxCode === baseCode);
  const isValidCategory = ['0', '1'].includes(categoryModifier);
  const isValidEntity = ['0', '1'].includes(entityModifier);
  
  return isValidBase && isValidCategory && isValidEntity;
};

// Pre-configured fiscal sponsor accounts
export const FISCAL_SPONSOR_BASE_ACCOUNTS = {
  Assets: {
    "1000": {
      name: "Operating Cash",
      type: "asset",
      subaccounts: {
        "1010": "Main Operating Account",
        "1020": "Administrative Fees Account"
      }
    },
    "1400": {
      name: "Fiscal Sponsorship Assets",
      type: "asset",
      subaccounts: {
        "1410": "Sponsored Project Bank Accounts",
        "1420": "Fiscal Sponsorship Receivables"
      }
    }
  },
  // ... other categories
};

// Automated account generation for new causes
export const generateCauseAccounts = (causeId: string, causeName: string) => {
  return {
    bankAccount: {
      code: `1410.${causeId}`,
      name: `${causeName} Bank Account`,
      type: "asset"
    },
    restrictedFunds: {
      code: `2310.${causeId}`,
      name: `${causeName} Restricted Funds`,
      type: "liability"
    },
    revenue: {
      code: `4100.${causeId}`,
      name: `${causeName} Contributions`,
      type: "revenue"
    }
  };
};

// Complete IRS Form 990 Categories
export const IRS_990_CATEGORIES = {
  PROGRAM_SERVICES: {
    code: "PS",
    categories: {
      // Part IX Line 1-4: Program Service Expenses
      "PS100": {
        name: "Grants and Assistance to Domestic Organizations",
        subcategories: {
          "PS101": "Public Charities",
          "PS102": "Private Foundations",
          "PS103": "Other Domestic Organizations"
        }
      },
      "PS200": {
        name: "Grants and Assistance to Domestic Individuals",
        subcategories: {
          "PS201": "Scholarships",
          "PS202": "Fellowship Grants",
          "PS203": "Research Grants",
          "PS204": "Other Assistance"
        }
      },
      "PS300": {
        name: "Grants to Foreign Organizations",
        subcategories: {
          "PS301": "Foreign Public Charities",
          "PS302": "Foreign Private Organizations",
          "PS303": "Foreign Governments"
        }
      },
      "PS400": {
        name: "Direct Program Activities",
        subcategories: {
          "PS401": "Environmental Conservation",
          "PS402": "Education Programs",
          "PS403": "Research Activities",
          "PS404": "Community Development",
          "PS405": "Health Services",
          "PS406": "Arts and Culture",
          "PS407": "Social Services",
          "PS408": "Religious Activities",
          "PS409": "Economic Development"
        }
      }
    }
  },
  SUPPORT_SERVICES: {
    code: "SS",
    categories: {
      // Part IX Line 5-24: Supporting Service Expenses
      "SS100": {
        name: "Management and General",
        subcategories: {
          "SS101": "Executive Compensation",
          "SS102": "Board Expenses",
          "SS103": "Legal Fees",
          "SS104": "Accounting Fees",
          "SS105": "Professional Fundraising",
          "SS106": "Investment Management",
          "SS107": "Lobbying Activities",
          "SS108": "Technology Support",
          "SS109": "Office Administration"
        }
      },
      "SS200": {
        name: "Fundraising",
        subcategories: {
          "SS201": "Direct Mail Campaigns",
          "SS202": "Special Events",
          "SS203": "Grant Writing",
          "SS204": "Online Fundraising",
          "SS205": "Major Gifts Program"
        }
      }
    }
  },
  REVENUE: {
    code: "REV",
    categories: {
      // Part VIII: Revenue Categories
      "REV100": {
        name: "Contributions and Grants",
        subcategories: {
          "REV101": "Public Support",
          "REV102": "Government Grants",
          "REV103": "Private Grants",
          "REV104": "Membership Dues"
        }
      },
      "REV200": {
        name: "Program Service Revenue",
        subcategories: {
          "REV201": "Fee for Service",
          "REV202": "Contract Revenue",
          "REV203": "Government Fees"
        }
      }
    }
  }
};

// Version control for IRS requirements
export const IRS_REQUIREMENTS_VERSION = {
  year: 2024,
  version: "1.0",
  lastUpdated: "2024-01-01",
  changes: [
    {
      date: "2024-01-01",
      description: "Initial comprehensive mapping",
      affectedCodes: []
    }
  ]
};

// Nonprofit Type Validation
export const NONPROFIT_TYPES = {
  "501c3": {
    name: "Charitable Organization",
    allowedCategories: ["PS", "SS", "REV"],
    requiredReporting: ["990", "Schedule A"],
    validationRules: {
      programExpenseRatio: 0.65, // Must spend 65% or more on programs
      fundraisingLimit: 0.35 // Fundraising costs shouldn't exceed 35%
    }
  },
  "501c4": {
    name: "Social Welfare Organization",
    allowedCategories: ["PS", "SS", "REV"],
    requiredReporting: ["990"],
    validationRules: {
      lobbyingAllowed: true,
      politicalActivity: "limited"
    }
  }
};

// Export utility functions
export const accountingUtils = {
  validateTaxCode,
  generateTaxCode,
  checkIRSUpdates,
  getCategoryDetails
};

export const getBaseCategory = (purpose: string, causeType: string) => {
  switch (purpose) {
    case 'grant_specific':
      return `PS400.${causeType}`;
    case 'special_purpose':
      return `PS401.${causeType}`;
    case 'program_service':
      return `PS402.${causeType}`;
    case 'fundraising':
      return `SS200.${causeType}`;
    case 'administrative':
      return `SS100.${causeType}`;
    default:
      return `SS109.${causeType}`; // Default to administrative
  }
};

// Add these functions before they are used
function checkIRSUpdates(category, entityType) {
  // Basic implementation
  return {
    needsUpdate: false,
    lastChecked: new Date()
  };
}

function getCategoryDetails(category) {
  // Basic implementation
  return {
    name: category,
    description: '',
    requirements: []
  };
} 